import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations.
import {
	BreakpointWidth,
} from '@app/enumerations';
// Import props.
import {
	ComparativeDataRowProps,
} from '@app/props';
// Import interfaces.
import {
	IAddress,
} from '@app/interfaces';

const useStyles = makeStyles((theme: Theme) => {

	const getBorderBottomStyle = (hideDivider: boolean | undefined): string =>
		(hideDivider ?? false)
			? 'none'
			: `1px solid ${theme.palette.info.main}`;

	return createStyles({
		comparativeAddressDataRow_container: {
			display: 'flex',
			borderBottom: (props: ComparativeDataRowProps<IAddress>) => getBorderBottomStyle(props.hideDivider),
			padding: (props: ComparativeDataRowProps<IAddress>) => {
				return theme.spacing(
					props.paddingProps?.top !== undefined ? props.paddingProps.top : 1.5,
					props.paddingProps?.right ?? 0,
					props.paddingProps?.bottom !== undefined ? props.paddingProps.bottom : 1.5,
					props.paddingProps?.left ?? 0)
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				flexDirection: 'row',
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				flexDirection: 'column'
			},
		},
		comparativeAddressDataRow_fieldLabelColumn: {
			fontWeight: theme.typography.fontWeightBold,
			flex: '1 0 33%',
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				marginBottom: theme.spacing(2),
			},
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		comparativeAddressDataRow_valueColumns: {
			display: 'flex',
			flex: '1 0 66%',
		},
		comparativeAddressDataRow_valueColumn: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			flex: '1 0 50%',
		},
		comparativeAddressDataRow_valueText: {
			color: theme.palette.info.main,
		},
		comparativeAddressDataRow_valueTextChanged: {
			color: theme.palette.error.main,
		},
		comparativeAddressDataRow_addressContainer: {
			display: 'flex',
			flexDirection: 'column',
		},
		comparativeAddressDataRow_addressLine: {
			display: 'flex',
			flexDirection: 'row',
			padding: theme.spacing(1, 0),
		},
	});
});

export default useStyles;
